import { translateFn } from '../../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../../ui/gzDataTable/types';
import { macValidators, networkValidators, typeValidators } from '../../utils/validators';
import { FormValidator } from '../../../../../../../../ui/gzForm/formField/types/form-validator';
import {
  getNetworkIdentification,
  getNetworkTypeFormOptions,
} from '../../../../../utils/uiSettings/firewall/firewall.values';
import { html, TemplateResult } from 'lit';
import { FirewallNetworkIdentification } from '@nirvana/shared/dtos/types/policies/common';

export enum ColumnKeys {
  NETWORK = 'network',
  TYPE = 'type',
  IDENTIFICATION = 'identification',
  MAC = 'domainMac',
  IP = 'ip',
}

export function getTableColumns(ipValidators: FormValidator<string>[]): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.NETWORK,
      header: translateFn('Network name'),
      columnType: IColumnType.TEXT,
      validators: networkValidators(),
    },
    {
      key: ColumnKeys.TYPE,
      header: translateFn('Network profile'),
      columnType: IColumnType.SINGLE_SELECT,
      options: getNetworkTypeFormOptions(),
      validators: typeValidators(),
    },
    {
      key: ColumnKeys.IDENTIFICATION,
      header: translateFn('Identification'),
      columnType: IColumnType.DISPLAY,
      options: getNetworkIdentification(),
      renderer: identificationCellCustomRenderer,
    },
    {
      key: ColumnKeys.MAC,
      header: translateFn('MAC'),
      columnType: IColumnType.TEXT,
      validators: macValidators(),
    },
    {
      key: ColumnKeys.IP,
      header: translateFn('IP'),
      columnType: IColumnType.TEXT,
      validators: ipValidators,
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}

export function identificationCellCustomRenderer(
  content: FirewallNetworkIdentification,
  column: IDataTableColumn,
  rowIndex: number
): TemplateResult {
  const displayValue = column.options?.find(item => item.value === content);
  const formattedContent = displayValue ? displayValue.label : content;

  return html`
    <gz-tooltip isEllipsis tooltipText="${formattedContent}" class="cell-label">${formattedContent}</gz-tooltip>
  `;
}
